import { Button } from '@/components/ui/button';

// What the selection can do, said out loud.
//
// It is not only a convenience. Dragging is a pointer gesture, so without this
// bar there would be destinations a mouse and a finger could reach that a
// keyboard could not.

interface JobFileSelectionBarProps {
  count: number;
  onMove: () => void;
  onShare: () => void;
  onClear: () => void;
}

export function JobFileSelectionBar({ count, onMove, onShare, onClear }: JobFileSelectionBarProps) {
  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-2 rounded border border-blue-200 bg-blue-50 px-3 py-2"
    >
      <span className="flex-1 text-sm font-medium text-blue-900">
        {count} {count === 1 ? 'file' : 'files'} selected
      </span>
      <Button size="sm" onClick={onMove}>
        Move
      </Button>
      <Button size="sm" variant="outline" onClick={onShare}>
        Share
      </Button>
      <Button size="sm" variant="outline" onClick={onClear}>
        Clear
      </Button>
    </div>
  );
}
